import React from 'react';
import SimplePageHeader from '@/header/SimplePageHeader';
import ContactsAndOfficesTabs from '@/header/ContactsAndOfficesTabs';

function ContactsAndOfficesHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <ContactsAndOfficesTabs active={active} />
        </SimplePageHeader>
    );
}

export default ContactsAndOfficesHeader;
